import { createContext } from 'react';
import type { PhoneLoginParams, PhoneLoginResponse } from '@zaogig/types';

export interface AuthUser {
  accountId: string;
  currentRole: 'worker' | 'employer';
  roles: { worker: boolean; employer: boolean; admin: boolean };
  nextStep: string;
}

export interface AuthContextValue {
  /** Current user (null if not authenticated) */
  user: AuthUser | null;
  /** Whether we're checking stored session on mount */
  loading: boolean;
  /** Login with phone + code */
  login: (params: PhoneLoginParams) => Promise<PhoneLoginResponse>;
  /** Logout — clears tokens and user state */
  logout: () => void;
  /** Auth tokens */
  token: string | null;
  refreshToken: string | null;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
